export default function WhatSetsUsApart() {
  const features = [
    {
      title: 'Unrivaled Access',
      description:
        'Bucket List Series opens the doors to the most exclusive courses and experiences in golf. From premium tee gifts to private wine dinners and unforgettable on-course activations, our events create unprecedented partnership opportunities.',
      image: 'https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/b0b0b0b0b0b0b0b0b0b0b0b0b0b0b0b0.jpg',
    },
    {
      title: 'Curated Experiences',
      description:
        "Our events are not just tournaments—they're journeys. Each gathering is thoughtfully designed to deliver something special—combining world-class hospitality, unique surprises, and unforgettable moments that must be shared.",
      image: 'https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/a0a0a0a0a0a0a0a0a0a0a0a0a0a0a0a0.jpg',
    },
    {
      title: 'True Community',
      description:
        "Our members aren't just participants—they're family. They treat Thousand Greens as their home club and look to the Bucket List Series as their way to reconnect, compete, and celebrate with their golf family.",
      image: 'https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/d0d0d0d0d0d0d0d0d0d0d0d0d0d0d0d0.jpg',
    },
    {
      title: 'Member-Driven',
      description:
        'Many of our events are made possible by the generosity and passion of our own members, who open the gates to their home clubs and help create extraordinary experiences for all.',
      image: 'https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/e0e0e0e0e0e0e0e0e0e0e0e0e0e0e0e0.jpg',
    },
  ];

  return (
    <section id="what-sets-us-apart" className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            What Sets Us Apart
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-green-700 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="h-48 sm:h-56 md:h-64 w-full overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    if (index === 1) {
                      target.src = 'https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/16d2f908d56cf7d78c9da2ec1e75134a.jpeg';
                    } else if (index === 2) {
                      target.src = 'https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/2e7be6eccc2d8ccf74407d04d9599535.jpeg';
                    } else if (index === 3) {
                      target.src = 'https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/a8b494a40f3a4e517b273e1ce0087a9d.jpeg';
                    } else {
                      target.src = 'https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/5273a3e00eb97d0fc20d66147235821c.jpeg';
                    }
                  }}
                />
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                  {feature.title}
                </h3>
                <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}